export const FAQS_LIST_SECTION_ID = 'faqs';
